// Common
import Launch from "@/components/launch/launch";
import NotFound from "@/components/404/404";
import Hero from "@/components/hero/hero";
import BestSellers from "@/components/products/best-sellers";
import ProductShowcase from "@/components/products/product-showcase";
import VideoShowcase from "@/components/pages/video-showcase";
import CustomerReviews from "@/components/pages/customer-reviews";
import DashboardLayout from "@/components/dashboard/dashboard";
import PrivateRoute from "@/utils/PrivateRoute";
import Seo from "@/seo/seo";
import { routeSeoConfig } from "@/utils/seo-config";

// Route groups
import { publicRoutes } from "./publicroutes";
import { authRoutes } from "./authroutes";
import { adminRoutes } from "./adminroutes";
// import SpotlightProducts from "@/components/products/spotlight-products";
// import SocialMediaFeed from "@/components/pages/social-media-feed";

export const appRoutes = (isLaunched) => [
  {
    path: "/",
    element: isLaunched ? (
      <>
        <Seo {...routeSeoConfig.home} type="website" />
        <Hero />
        <ProductShowcase />
        {/* <VideoShowcase /> */}
        <BestSellers />
        {/* <SpotlightProducts /> */}
        {/* <SocialMediaFeed /> */}
        <CustomerReviews />
      </>
    ) : (
      <Launch />
    ),
  },

  ...(isLaunched
    ? [
        ...authRoutes,
        ...publicRoutes,
        {
          element: <PrivateRoute />,
          children: [{ path: "/dashboard/*", element: <DashboardLayout /> }],
        },
        ...adminRoutes,
        { path: "*", element: <NotFound /> },
      ]
    : [{ path: "*", element: <Launch /> }]),
];
